"use strict";
export var KeyType = /* @__PURE__ */ ((KeyType2) => {
  KeyType2["Enter"] = "Enter";
  KeyType2["Backspace"] = "Backspace";
  KeyType2["Delete"] = "Delete";
  KeyType2["Tab"] = "Tab";
  KeyType2["I"] = "i";
  KeyType2["B"] = "b";
  KeyType2["K"] = "k";
  KeyType2["Dash"] = "-";
  KeyType2["Escape"] = "Escape";
  KeyType2["AngleBracketClose"] = ">";
  KeyType2["ArrowUp"] = "ArrowUp";
  KeyType2["ArrowDown"] = "ArrowDown";
  KeyType2["ArrowLeft"] = "ArrowLeft";
  KeyType2["ArrowRight"] = "ArrowRight";
  KeyType2["Space"] = " ";
  KeyType2["Ctrl"] = "Control";
  KeyType2["CurlyBracketOpen"] = "{";
  KeyType2["BackTick"] = "`";
  KeyType2["CloseBracket"] = ")";
  KeyType2["OpenBracket"] = "(";
  KeyType2["CloseSquareBracket"] = "]";
  KeyType2["CapitalP"] = "P";
  KeyType2["CapitalD"] = "D";
  KeyType2["CapitalO"] = "O";
  KeyType2["Line"] = "|";
  KeyType2["Slash"] = "/";
  KeyType2["Three"] = "3";
  KeyType2["Colon"] = ":";
  KeyType2["Plus"] = "+";
  return KeyType2;
})(KeyType || {});
export var MouseButtonType = /* @__PURE__ */ ((MouseButtonType2) => {
  MouseButtonType2[MouseButtonType2["Left"] = 0] = "Left";
  MouseButtonType2[MouseButtonType2["Middle"] = 1] = "Middle";
  MouseButtonType2[MouseButtonType2["Right"] = 2] = "Right";
  return MouseButtonType2;
})(MouseButtonType || {});
